import React from "react";
import { createPortal } from "react-dom";
import {
    ModalWrapper,
    ModalBox,
    ModalClose,
    Backdrop,
} from "./ModalStyledComponents";

export interface ModalProps {
    open: boolean;
    onClose?: () => void;
    children?: React.ReactNode;
    hideClose?: boolean;
}

export interface BackdropProps {
    open: boolean;
}

const Modal = ({ children, open, onClose, hideClose = false }: ModalProps) =>
    open
        ? createPortal(
              <ModalWrapper>
                  <ModalBox>
                      {!hideClose && (
                          <ModalClose onClick={onClose}>x</ModalClose>
                      )}
                      {children}
                  </ModalBox>
                  <Backdrop open={open} />
              </ModalWrapper>,
              document.body
          )
        : null;

export default Modal;
